import { initializeApp } from "firebase/app";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";
// Firebase App Check is temporarily disabled in production

const firebaseConfig = {
 apiKey: "AIzaSyAtYgrVSHWTTP9Nadx_id_dzEKGf5q9eLY",
  authDomain: "new-hub-2bf76.firebaseapp.com",
  projectId: "new-hub-2bf76",
  storageBucket: "new-hub-2bf76.firebasestorage.app",
  messagingSenderId: "645310345158",
  appId: "1:645310345158:web:98248f1074c2e5450b4cc7",
  measurementId: "G-K9FX8STXL7"
};

const app = initializeApp(firebaseConfig);

// Development bypass strategy for App Check
if (process.env.NODE_ENV !== 'production') {
  if (typeof window !== 'undefined') {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
}

// Initialize Firebase App Check with reCAPTCHA Enterprise
// NOTE: Replace "YOUR_RECAPTCHA_ENTERPRISE_SITE_KEY" with the actual site key from Google Cloud Console.
/* 
initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider("YOUR_RECAPTCHA_ENTERPRISE_SITE_KEY"),
  isTokenAutoRefreshEnabled: true
});
*/

// Initialize Firestore and enable offline persistence for better reliability
const db = getFirestore(app);
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.warn('Multiple tabs open, offline persistence can only be enabled in one tab at a time.');
  } else if (err.code === 'unimplemented') {
    console.warn('The current browser does not support offline persistence.');
  }
});

// Initialize Analytics conditionally (client-side only)
isSupported().then((supported) => {
  if (supported) {
    getAnalytics(app);
  }
});

export default app;